import { WorklistPage } from "@/features/worklist/components/WorklistPage";
import { requireTab } from "@/features/navigation/requireTab";
import {
    clinicianWorklistQueryOptions,
    incompleteDataDiariesQueryOptions,
    worklistConsentsQueryOptions,
} from "@/features/worklist/api/worklistQueryOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/worklist")({
    beforeLoad: ({ context }) => requireTab(context, "worklist"),
    component: WorklistPage,
    loader: async ({ context }) => {
        await Promise.all([
            context.queryClient.ensureQueryData(clinicianWorklistQueryOptions()),
            context.queryClient.ensureQueryData(incompleteDataDiariesQueryOptions()),
            context.queryClient.ensureQueryData(worklistConsentsQueryOptions()),
        ]);
    },
});
